import { ExpectedTaskAnswerMetadata, Task } from "@jelly/lesson";

const items = [
  {
    id: "c80ffa51-6432-4cf3-8121-b946a4dcbb0e",
    content: "Only the generation of higher order image sources",
    options: {},
  },
  {
    id: "a25634df-c61d-4e04-ace9-77318793e383",
    content: "Generation and audibility test of all image sources",
    options: {},
  },
  {
    id: "3adf23d3-1259-4a9c-88b2-ff7022c7ab0e",
    content: "Audibility tests for all image sources",
    options: {},
  },
  {
    id: "638aaa2c-1ead-4328-bd6a-35bf4ab3f3f6",
    content: "Generation of all image sources",
    options: {},
  },
];

export const task: Task = {
  id: "f9790c4d-551f-4415-aad1-a98d6b6164e8",
  solutionType: "select",
  type: "checkbox",
  options: {
    columns: 1,
    isMultiple: false,
    shuffle: true,
  },
  items,
};

export const expectedAnswerMetadata: ExpectedTaskAnswerMetadata = {
  solutionType: "select",
  data: ["3adf23d3-1259-4a9c-88b2-ff7022c7ab0e"],
};
